import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import Router from './routes/router';
import ConsoleList from './page_elements/ConsoleList';
import GameList from './page_elements/GameList';
import GamePlayer from './page_elements/GamePlayer';
import Topbar from './page_elements/Topbar';
import {createTheme, ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
var API_URL = process.env.VIDEOGAME_API_URL


const dacula_theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
          main: '#bd93f9',
        },
        background: {
          paper: '#44475a',
          default: '#282a36',
        },
        divider: '#44475a',
    },
})

function App() {
  console.log(API_URL);
  const [gameId, setGameId] = React.useState(0);
  const [consoleState, setConsoleState] = React.useState({console_id: 0, core: "2600"});
  const [current_page, setCurrentPage] = React.useState(0);

  const handleConsoleChange = (console_id, core) => {
    setConsoleState({console_id: console_id, core: core});
    setCurrentPage(1);
  }

  const handleGameChange = (game_id) => {
    setGameId(game_id);
    setCurrentPage(2);
  }

  const handleBack = () => {
    setCurrentPage(current_page - 1);
  }

  let element;
  if (current_page === 0) {
    element = <ConsoleList handleConsoleChange={handleConsoleChange} />;
  } else if (current_page === 1) {
    element = <GameList id={consoleState.console_id} handleGameChange={handleGameChange} />;
  } else if (current_page === 2) {
    element = <GamePlayer id={gameId} console_id={consoleState.console_id} core={consoleState.core} handleBack={handleBack} />;
  }

  return <> 
    <ThemeProvider theme={dacula_theme}>
      <Router/>
    </ThemeProvider>
  </>

}

export default App;
